import { Box, InputAdornment, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  HeaderFilterBox,
  CustomAutoComplete,
  CustomTextField,
} from '../../../common/components';

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos los estados' },
  { value: 'active', label: 'Activos' },
  { value: 'inactive', label: 'Inactivos' },
];

const InventoryArticlesFilters = ({
  filters,
  onFilterChange,
  searchTerm,
  onSearchChange,
}) => {
  const inputStyles = {
    width: { xs: '100%', sm: '48%', md: '22%' },
    mt: 0,
  };

  return (
    <HeaderFilterBox variant="oneRow">
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'center',
          width: '100%',
        }}
      >
        <CustomTextField
          label="Buscar artículo"
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Código, nombre, descripción o código externo"
          size="medium"
          sx={{ ...inputStyles, width: { xs: '100%', sm: '48%', md: '40%' } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'primary.main' }} />
              </InputAdornment>
            ),
          }}
        />

        <CustomAutoComplete
          label="Estado"
          value={filters.status}
          onChange={(event) => onFilterChange('status', event.target.value)}
          size="medium"
          sx={inputStyles}
        >
          {STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomAutoComplete>
      </Box>
    </HeaderFilterBox>
  );
};

export default InventoryArticlesFilters;
